<ng-container *ngIf="values">
  <apx-chart
    [series]="values"
    [chart]="chartOptions.chart"
    [dataLabels]="chartOptions.dataLabels"
    [plotOptions]="chartOptions.plotOptions"
    [labels]="chartOptions.labels"
    [title]="chartOptions.title"
    [responsive]="chartOptions.responsive"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [legend]="chartOptions.legend"
    [theme]="chartOptions.theme"
    [fill]="chartOptions.fill"></apx-chart>
</ng-container>
